import React, {useState} from "react";
import style from "../style.module.sass"
import {useTheme} from "@material-ui/core/styles";
import TypeOfField from "../../../../../../components/FormikFields/TypeOfField";
import {Collapse} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { useTranslation } from "react-i18next";

export default function GroupProfile({formik, companies, id}) {
  const [bg, setBg] = useState(false)
  const { t } = useTranslation();
  const [collapse, setCollapse] = useState(true)
  const {theme: {bgColors, colors}} = useTheme()

  const fields = [
    { id: "1", control: "text", name: "groupName", label: t("admin_group_group-name") },
    { id: "2", control: "select", name: "company", label: t("admin_group_company"), options: companies },
  ]

  switch (!!id) {
    case true:
      fields.push(
        { id: "3", control: "text", name: "groupId", label: t("admin_group_groupId"), disabled: true },
        { id: "4", control: "date", name: "create_time", label: t("admin_group_create-time"), disabled: true },
        { id: "5", control: "date", name: "update_time", label: t("admin_group_update-time"), disabled: true }
      )
      break
    default:
      break
  }

  return (
    <div style={{backgroundColor: !bg ? bgColors.bgPrimary0 : bgColors.bgBlue50}}
         onMouseEnter={() => setBg(true)} onMouseLeave={() => setBg(false)}>
      <div style={{backgroundColor: bgColors.bgPrimary500}}
           className={`${style.header} ${style.borderTop} d-flex align-items-center justify-content-between pr-4`}>
        <h4 style={{color: colors.colorPrimary0}}
            className={style.title}>{t('admin_group_group-profile')}</h4>
        <button className={`ml-2 p-0`} onClick={(e) => {
          e.preventDefault()
          setCollapse(!collapse)
        }}>
          {!collapse ? <AddIcon style={{fill: "white"}} fontSize="small"/> :
            <RemoveIcon style={{fill: "white"}} fontSize="small"/>}
        </button>
      </div>
      <Collapse in={collapse}>
        <ul className={`mb-0`}>
          {
            fields.map(
              f => (
                <li key={f.id}>
                  <TypeOfField control={f.control} formik={formik} name={f.name} label={f.label} {...f}/>
                </li>
              )
            )
          }
        </ul>
      </Collapse>
    </div>
  )
};
